var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 14.4375L3.9375 7.87505L4.85625 6.9563L10.5 12.6L16.1438 6.9563L17.0625 7.87505L10.5 14.4375Z","fill":"#85B336"}));
}

Down.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Down;

Down.default = Down;
